export default "__VITE_ASSET__9c0ee7af__"